@if (urlSuffix === 'create') {
  <ui-srm-create></ui-srm-create>
} @else if (urlSuffix; as ticketIdentifier) {
  <ui-srm-details [ticketIdentifier]="ticketIdentifier"></ui-srm-details>
} @else {
  <ui-srm-overview></ui-srm-overview>
}
